var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUploadLaptop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 4.16667H6.66663C5.56206 4.16667 4.66663 5.0621 4.66663 6.16667V13.3333H16.3333V10.4167",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9167 7.5L15.9167 2.5M15.9167 2.5L18 4.58333M15.9167 2.5L13.8333 4.58333",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.3333H18V13.8333C18 14.9379 17.1046 15.8333 16 15.8333H5C3.89543 15.8333 3 14.9379 3 13.8333V13.3333Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLaptop);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMS4zMzMzIDQuMTY2NjdINi42NjY2M0M1LjU2MjA2IDQuMTY2NjcgNC42NjY2MyA1LjA2MjEgNC42NjY2MyA2LjE2NjY3VjEzLjMzMzNIMTYuMzMzM1YxMC40MTY3IiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNS45MTY3IDcuNUwxNS45MTY3IDIuNU0xNS45MTY3IDIuNUwxOCA0LjU4MzMzTTE1LjkxNjcgMi41TDEzLjgzMzMgNC41ODMzMyIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMyAxMy4zMzMzSDE4VjEzLjgzMzNDMTggMTQuOTM3OSAxNy4xMDQ2IDE1LjgzMzMgMTYgMTUuODMzM0g1QzMuODk1NDMgMTUuODMzMyAzIDE0LjkzNzkgMyAxMy44MzMzVjEzLjMzMzNaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };